import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import {connect} from "react-redux";

import { 
  ControlBar, 
  ControlGroup, 
  Control, 
  QuickControl, 
  DateControl,
  DateClearControl
} from './Controls.js'

import DateModal from './DateModal.js'

import { 
  selectIsModalActive,
  selectActiveModal,
  selectActiveFilters,
  selectFiltersByParam
} from '../../Search/State/selectors.js'

import {
  openModal,
  replaceAndExecuteFilter,
  deactivateFilterGroup
} from '../../Search/State/actions.js'

/* This is a list of interface supported quick ranges. */
//const QuickRanges = ["This Weekend"]

const mapStateToProps = (state) => {
  var isModalActive = selectIsModalActive(state)
  var activeModal = selectActiveModal(state)
  var activeFilters = selectActiveFilters(state)
  var dateFilter = (selectFiltersByParam(state, "narrowByDate") || [])[0] || {}

  dateFilter = activeFilters.map(f => f.param).includes("narrowByDate") ? dateFilter : {}

  // eslint-disable-next-line no-console
  // console.log(" [ DEBUG ] TOKEN GROUPS : groups :  ", tokenGroups)

  return { isModalActive, activeModal, activeFilters, dateFilter }
}

const actions = {
  openModal,
  replaceAndExecuteFilter,
  deactivateFilterGroup
}


class EventDateController extends React.Component {
  static get propTypes () {
    return {
      isModalActive: PropTypes.bool,
      activeModal: PropTypes.string,
      activeFilters: PropTypes.array, 
      openModal: PropTypes.func,
      deactivateFilterGroup: PropTypes.func,
      replaceAndExecuteFilter: PropTypes.func,
      dateFilter: PropTypes.object
    }
  }

  constructor () {
    super()
  }

  getQuickDates () {
    var today = moment()
    var out = [today]

    for (var i = 1; i < 7; i++) {
      out.push(moment(today).add(i, "d"))
    }
    return out
  }

  setQuickFilter (date) {
    this.props.replaceAndExecuteFilter({
      param:"narrowByDate",
      paramName:"Date",
      value: date.format("YYYY-MM-DD"),
      name: date.format("ddd, MMM D"), 
      prep:"on"
    })
  }

  setQuickRangeFilter (id) {
    this.props.replaceAndExecuteFilter({
      param:"narrowByDate",
      paramName:"Date",
      value:id,
      name:({"This Weekend":"This Weekend", "Next Week":"Next Week"})[id], 
      prep:"on"
    })
  }

  setFromDate (date) {
    this.props.replaceAndExecuteFilter({
      param:"narrowByDate",
      paramName:"Date",
      value: date.format("YYYY-MM-DD"),
      name: date.format("ddd, MMM D"), 
      prep:"on"
    })
  }

  setToDate (toDate) {
    var { fromDate } = translateDateValue(this.props.dateFilter.value)
    this.props.replaceAndExecuteFilter({
      param:"narrowByDate",
      paramName:"Date",
      value: `${fromDate.format("YYYY-MM-DD")}-to-${toDate.format("YYYY-MM-DD")}`,
      name: `${fromDate.format("ddd, MMM D")} ➔  ${toDate.format("ddd, MMM D")}`, 
      prep:"on"
    })
  }

  clearDateFilters () {
    this.props.deactivateFilterGroup("Date")
  }

  isQuickDateActive (date) {
    var filter = this.props.dateFilter
    var { fromDate, toDate } = translateDateValue(filter.value)

    if (toDate) {
      return false
    }
    if (fromDate && fromDate.format("YMD") === date.format("YMD")) {
      return true
    }
    return false
  }

  isQuickRangeActive (rangeString) {
    var filter = this.props.dateFilter
    if (filter.value === rangeString) {
      return true
    }
    return false
  }

  toggleDateModal (target) {
    this.props.openModal(`date-${target}`)
  }

  render () {
    var { fromDate, toDate } = translateDateValue(this.props.dateFilter.value)
    var quickDates = this.getQuickDates()

    return (

      <div className="SearchController" >

        <ControlBar>
          <ControlGroup>
            <DateClearControl handleClick={() => {this.clearDateFilters()}} />
          </ControlGroup>

          <ControlGroup  classNames="fdn-date-quick-links">
            { quickDates.map((date, i) => {
              return (
                <Control key={`date-${i}`}
                  date={date} 
                  active={this.isQuickDateActive(date)}
                  handleClick={() => this.setQuickFilter(date)} 
                />
              )
            })}
          </ControlGroup>

          <ControlGroup>
            <QuickControl handleClick={() => { this.setQuickRangeFilter("This Weekend")}} 
              active={this.isQuickRangeActive("This Weekend")}
              copy="This Weekend" 
            />
          </ControlGroup>

          <ControlGroup>
            {([<DateControl 
                key="1"
                handleClick={() => { }} 
                date={fromDate}
                copy="Start Date" />
                ,

              <DateModal fromDate={fromDate} toDate={toDate}
                key="2"
                type="from"
                handleToDateSelect={this.setToDate.bind(this)}
                handleFromDateSelect={this.setFromDate.bind(this)}/> 
              ])}
            
          </ControlGroup>

            { fromDate && <span className="verbage">&nbsp;to&nbsp;</span> }

          <ControlGroup>
            { fromDate && (
              [ 
                <DateControl 
                  key="3"
                  handleClick={() => { }}
                  date={toDate}
                  copy={"End Date"}/> 
                ,

                <DateModal fromDate={fromDate} toDate={toDate}
                  key="4"
                  type="to"
                  handleToDateSelect={this.setToDate.bind(this)}
                  handleFromDateSelect={this.setFromDate.bind(this)}/> 
              ])}
              
           
          </ControlGroup>
        </ControlBar>
      </div>
    )
  }
}

export default connect(mapStateToProps, actions)(EventDateController);


function translateDateValue ( value ) {
  if (!value) {
    return {
      fromDate: null,
      toDate: null
    }
  }

  let fromDate = moment(value)
  if (fromDate.isValid()) {
    return {
      "fromDate":fromDate,
      "toDate" : null
    }
  }
  else if (value.search("-to-") >= 0) {
    var dates = value.split("-to-")
    let fromDate = moment(dates[0])
    let toDate = moment(dates[1])

    fromDate = fromDate.isValid() ? fromDate : null
    toDate = toDate.isValid() ? toDate : null 
    return {
      fromDate,
      toDate
    }
  } 
  else {
    switch (value.toLowerCase()) {
      case "today":
        return { "fromDate" : moment() }
      case "tomorrow":
        return { "fromDate" : moment().add(1, "d") }
      case "this weekend":
        return { 
          "fromDate" : moment().startOf('isoWeek').add(4, 'd'), 
          "toDate" : moment().startOf('isoWeek').add(6, 'd') 
        }
      case "next weekend":
        return { 
          "fromDate" : moment().startOf('isoWeek').add(11, 'd'), 
          "toDate" : moment().startOf('isoWeek').add(13, 'd') 
        }
      case "next week":
        return { 
          "fromDate" : moment().startOf('isoWeek').add(6, 'days'), 
          "toDate" : moment().startOf('isoWeek').add(12, 'd') 
        }
      case "this week":
      case "next 7 days":
        return {
          "fromDate" : moment(),
          "toDate" : moment().add(6, 'd')
        }
      case "next 30 days":
        return {
          "fromDate" : moment(),
          "toDate" : moment().add(29, 'd')
        }
      default:
        return {
          "fromDate" : null,
          "toDate" : null
        }
    }
  }
}
